import React, { Fragment } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import EntryForm, { ConfirmationCard } from 'Layout/EntryForm'
import Link from 'Design/components/Link'

const Footer = () => {
  return (
    <Fragment>
      <strong> Did not receive mail? </strong> Write to us at{' '}
      <Link href='mailto:support@happyfox.com'>support@happyfox.com</Link>
    </Fragment>
  )
}

const cardProps = {
  emoji: '👍',
  title: 'Email to reset password sent successfully',
  body: `Check your email for a link to reset your password. If it doesn't appear within a few minutes, check your
    spam folder.`,
  footer: <Footer />
}

const ResetPasswordSuccess = () => {
  const { state } = useLocation()

  if (!state || !state.email) {
    return <Navigate to='../' replace />
  }

  return (
    <EntryForm>
      <ConfirmationCard {...cardProps} />
    </EntryForm>
  )
}

export default ResetPasswordSuccess
